<ul class="nav nav-tabs custom top">
    <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#b_payments">Bill Payments</a>
    </li>
    <li class="nav-item" *ngIf="is_xero">
        <a class="nav-link" data-toggle="tab" href="#x_payments">Xero Payments</a>
    </li>
</ul>
<div class="tab-content top">
    <div class="tab-pane active" id="b_payments">
        <div class="row">
            <div class="col-md-12">
                <h5><h6><i>Bill Payment History</i></h6></h5>
                <br/>
                <button class="btn btn-sm btn-success  mb-1" (click)="openModalAddUpdatePayment(null)">
                    <i class="fa fa-lg fa-plus"></i> Add New Bill Payment
                </button>
                <span class="float-right"><span class="text-success">Status :</span>&nbsp;{{ (balance==0 && amount_paid == bill.total_amount) ? 'Paid' : (amount_paid > 0 && balance > 0 ?'Partially Paid': 'Unpaid') }}
                    &nbsp;&nbsp;<span class="text-success">Total Paid :</span>&nbsp; {{amount_paid | currency:'USD':'symbol'}} &nbsp;&nbsp; <span class="text-success">Balance :</span> &nbsp;{{balance | currency:'USD':'symbol'}}</span>
                <ngx-datatable  
                    class="material"
                    [rows]="b_payments"
                    [columnMode]="'force'"
                    [columns]="b_columns"
                    [footerHeight]="30"
                    [rowHeight]="'auto'"
                    [limit]="10"
                    [selectionType]="'single'"
                    >
                <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="100">
                    <ng-template let-value="value" let-row="row"  ngx-datatable-cell-template>
                        <div align="left" style="padding-right:20px">
                            <span [class.disabled]="spinner == false" class="cursorhover" title="Edit Payment" (click)="openModalAddUpdatePayment(row)"><i class="fa fa-lg fa-edit"></i></span>&nbsp; 
                            <span [class.disabled]="spinner == false" class="cursorhover" title="Delete Payment" (click)="openModalDelete(row)"><i class="fa fa-lg fa-trash"></i></span>&nbsp;
                        </div>
                    </ng-template>
                </ngx-datatable-column>
        
                <ngx-datatable-column prop="date" name="Payment Date" headerClass="header"  [width]="100">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                    </ng-template>
                </ngx-datatable-column>
        
                <ngx-datatable-column prop="description" headerClass="header" name="Description" [width]="100"></ngx-datatable-column>
                
                <ngx-datatable-column prop="payment_type_name" headerClass="header" name="Payment Method" [width]="100"></ngx-datatable-column>
        
                <ngx-datatable-column prop="paid_amount" headerClass="header" name="Paid Amount" [width]="100">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="text-right">
                            {{ (row.paid_amount !== null) ?  (row.paid_amount | currency:'USD':true:'1.2-2') : "0"}} &nbsp;
                        </div>
                    </ng-template>
                </ngx-datatable-column>
        
                <ngx-datatable-column prop="reference_no" headerClass="header" name="Reference No." [width]="100"></ngx-datatable-column>
                
        
                <ngx-datatable-column prop="user_created" headerClass="header" name="Created By" [width]="100"></ngx-datatable-column>
        
                <ngx-datatable-column prop="user_updated" headerClass="header" name="Updated By" [width]="100"></ngx-datatable-column>
        
                <ngx-datatable-column prop="file" name="File" headerClass="header"  [width]="100">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        <a href="{{fileStoragePath}}/{{prefix_payments}}/{{value}}" target="_new">{{value}}</a>
                    </ng-template>
                </ngx-datatable-column>
        
                </ngx-datatable>
            </div>
        </div>
    </div>
    <div class="tab-pane" id="x_payments" *ngIf="is_xero">
        <div class="row">
            <div class="col-md-12">
                <h5><h6><i>Xero Payment History</i></h6></h5>
                <br/>
                <span class="float-right"><span class="text-success">Xero Total Payment :</span>&nbsp; {{xero_total | currency:'USD':true:'1.2-2'}}</span><br/>
                <ngx-datatable  
                class="material"
                [rows]="xero_payments"
                [columnMode]="'force'"
                [columns]="b_columns"
                [footerHeight]="30"
                [rowHeight]="'auto'"
                [limit]="10"
                [selectionType]="'single'"
                >
                    <ngx-datatable-column prop="Date" headerClass="header" name="Date" [width]="100">
                        <ng-template let-value="value" ngx-datatable-cell-template>
                            {{ (value !== null && value !== '') ? ( value | date: 'dd MMM yyyy' ) : "No Date"  }}
                        </ng-template>
                    </ngx-datatable-column>
                    
                    <ngx-datatable-column prop="Amount" headerClass="header" name="Payment Amount" [width]="100">
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                            <div class="text-right">
                                {{ (value !== null) ?  (value | currency:'USD':true:'1.2-2') : "0"}} &nbsp;
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="Reference" headerClass="header" name="Reference" [width]="100"></ngx-datatable-column>
            
            </ngx-datatable>
        </div>
    </div>
</div>    



<!-- Add Update Payment -->

<ng-template #modalAddUpdatePayment>
    <div class="modal-header">
        <h4 class="modal-title"><span *ngIf="!isEditMode">Add</span> <span *ngIf="isEditMode">Update</span> Payment Form</h4>
        <button type="button" class="close" (click)="closeFrmPayment()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <form [formGroup]="frm_payment" novalidate (ngSubmit)="onSubmit(frm_payment.value)">
        <div class="modal-body">
            <div class="row"> 
                <div class="form-group col-md-4">
                    <label class="form-control-label">Payment Date<span class="text-danger">*</span></label>
                    <input formControlName="date" class="form-control form-control-sm" type="date" required>
                    <div *ngIf="frm_payment.controls.date.touched">
                        <div *ngIf="frm_payment.controls.date.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>

                <div class="form-group col-md-4">
                    <label class="form-control-label">Description<span class="text-danger">*</span></label>
                    <input formControlName="description" class="form-control form-control-sm" type="text" required>
                    <div *ngIf="frm_payment.controls.description.touched">
                        <div *ngIf="frm_payment.controls.description.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>

                <div class="form-group col-md-4">
                    <label class="form-control-label">Payment Type<span class="text-danger">*</span></label>
                    <select formControlName="payment_type_id" class="form-control form-control-sm">
                        <option disabled value="Select Section">Select Type</option>
                        <option  *ngFor="let p of payment_types" value="{{p.id}}">{{p.name}}</option>
                    </select>
                    <div *ngIf="frm_payment.controls.payment_type_id.touched">
                        <div *ngIf="frm_payment.controls.payment_type_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                     </div>
                </div>
                
            </div>

            <div class="row">            
                <div class="form-group col-md-4">
                    <label class="form-control-label">Paid Amount<span class="text-danger">*</span></label>
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend"><span class="input-group-text">$</span></div>
                        <input formControlName="paid_amount" class="form-control form-control-sm" type="text" step="0.01" required>
                    </div>
                    <div *ngIf="frm_payment.controls.paid_amount.touched">
                        <div *ngIf="frm_payment.controls.paid_amount.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                        <div *ngIf="frm_payment.controls.paid_amount.errors?.pattern && !isAmt()">
                            <small class="text-danger">Amount must have a valid currency value.</small>
                        </div>
                    </div>
                </div>

                <div class="form-group col-md-4">
                    <label class="form-control-label"> Reference No.</label>
                    <input formControlName="reference_no" class="form-control form-control-sm" type="text">
                </div>   
                
                <div class="form-group col-md-4">
                    <div class="form-group" *ngIf ="(fileExists==true)">
                        <h6>File:</h6><br/>
                        <label>{{bill_payment?.file}}</label> <button class="btn btn-sm btn-primary" type="button" (click)="removeFile()">Remove File</button>
                    </div>
                    <div class="form-group" *ngIf ="(fileExists==false)">
                        <h6>File :</h6>
                        <app-file-uploader (passFile)="getFile($event)"></app-file-uploader>
                    </div>
                </div>
            </div>
        </div>
                
        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button  type="submit" class="btn btn-sm btn-success"  [disabled]="!frm_payment.valid || spinner == true">Save</button>
            <button type="button" class="btn btn-sm btn-secondary" [disabled]=" spinner == true" (click)="closeFrmPayment()">Cancel</button>
        </div>
    </form>
</ng-template>


<ng-template #modalDeletePayment let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete Payment Confirmation</h5>
        <button type="button" class="close" (click)="closeFrmDelete()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
               Are you sure to delete this bill record?<br/>
               Description :<strong> {{current_payment?.description}}</strong><br/>
               File :<strong> {{current_payment?.file}}</strong><br/>
               Amount :<strong> $ {{current_payment?.paid_amount |  number:'1.2-2' }}</strong><br/>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger" (click)="deletePayment()" [disabled]="spinner == true"><i class="fa fa-trash"></i>  Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeFrmDelete()">Cancel</button>
    </div>
</ng-template>